import { TextInputWithAutoSize } from "./textInputWithAutoSize";
import { TextInputWithMatchers } from "./textInputWithMatchers";
import { TextInputWithSuggestion } from "./textInputWithSuggestions";

export const BaseTextInputComponent = {
  TextInputWithSuggestion,
  TextInputWithAutoSize,
  TextInputWithMatchers,
};
